
/* Single image */
import img1 from '../images/service/airfreight.jpg'
import img2 from '../images/service/seafreight.jpg'
import img3 from '../images/service/roadfreight.jpg'
import img4 from '../images/service/warehouse.jpg'
import img5 from '../images/service/custom.jpg'
import img6 from '../images/service/logistics.jpg'
import img7 from '../images/service/heavy.jpg'
import img8 from '../images/service/cargo.jpg'
import img9 from '../images/service/relocation.jpg'


import Icon3 from '../images/service/icon-3.svg'
import Icon4 from '../images/service/icon-4.svg'

import Simg1 from '../images/service/airfreight.jpg'
import Simg2 from '../images/service/seafreight.jpg'
import Simg3 from '../images/service/roadfreight.jpg'
import Simg4 from '../images/service/warehouse.jpg'
import Simg5 from '../images/service/custom.jpg'
import Simg6 from '../images/service/logistics.jpg'
import Simg7 from '../images/service/heavy.jpg'
import Simg8 from '../images/service/cargo.jpg'
import Simg9 from '../images/service/relocation.jpg'

const Services = [
    {
        id: 1,
        image: img1,
        simag: Simg1,
        iconName: 'flaticon-road-with-broken-line',
        subtitle: 'Transport',
        title: 'Air Freight',
        description: 'Given airfreight’s sensitivity and time pressures, Our International Logistics develops comprehensive airfreight service plans tailored to our customers’ requirements. By understanding our customers’ exact objectives, we address the extreme time pressures and deadlines associated with sensitive and valuable goods. Our Airfreight Department creates customized service plans for each customer and implements required Operational Handling Procedures to ensure high-quality service. Our team of airfreight professionals manages every shipment, providing real-time status reports on all import and export airfreight shipments. For oversize cargo transportation by air, we offer expertise in handling part and full charter services, including complete door-to-door delivery logistics on a global scale.',
        slug: 'air-freight'
    },
    {
        id: 2,
        image: img2,
        simag: Simg2,
        iconName: 'flaticon-air-plane',
        subtitle: 'Freight',
        title: 'Sea Freight',
        description: 'Economical and scalable ocean freight services for full container loads (FCL), less than container loads (LCL), and bulk cargo worldwide.',
        slug: 'sea-freight'
    },
    {
        id: 3,
        image: img3,
        simag: Simg3,
        iconName: 'flaticon-boat-with-containers',
        subtitle: 'Projects',
        title: 'Road Freight',
        description: 'Dependable LTL and FTL transport solutions ensuring safe, on-time deliveries across Australia’s major cities and regional areas.',
        slug: 'road-freight'
    },
    {
        id: 4,
        image: img4,
        simag: Simg4,
        iconName: 'flaticon-warehouse',
        subtitle: 'Warehouse',
        title: 'Warehouse Management',
        description: 'Comprehensive warehousing services with secure storage, real-time inventory control, and efficient distribution management.',
        slug: 'management'
    },
    {
        id: 5,
        image: img5,
        simag: Simg5,
        iconName: 'flaticon-customer-support',
        subtitle: 'Consulting',
        title: 'Customs Clearance',
        description: 'Streamlined import and export processing with expert brokerage support to ensure full compliance and minimal delays.',
        slug: 'customs-clearance'
    },
    {
        id: 6,
        image: img6,
        simag: Simg6,
        iconName: 'flaticon-logistics',
        subtitle: 'Management',
        title: 'Project Logistics',
        description: 'Tailored end-to-end logistics strategies designed to manage complex, large-scale, and time-sensitive projects seamlessly.',
        slug: 'project-logistics'
    },
    {
        id: 7,
        image: img7,
        simag: Simg7,
        iconName: Icon3,
        subtitle: 'Transport',
        title: 'Heavy Lifts & Oversized Cargo',
        description: 'Specialised planning, equipment, and handling expertise for transporting oversized, high-value, and heavy cargo safely.',
        slug: 'heavy-lifts'
    },
    {
        id: 8,
        image: img8,
        simag: Simg8,
        iconName: Icon4,
        subtitle: 'Transport',
        title: 'Cargo Insurance',
        description: 'Comprehensive coverage options protecting your shipments against unforeseen loss, damage, or transit risks.',
        slug: 'cargo-insurance'
    },
    {
        id: 9,
        image: img9,
        simag: Simg9,
        iconName: Icon3,
        subtitle: 'Transport',
        title: 'Removals & Relocation',
        description: 'Professional relocation services delivering smooth, secure transitions for businesses and individuals locally and internationally.',
        slug: 'removals-relocation'
    },





];
export default Services;